import React from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { redirectToContact } from '../utils/productInquiry';
import { CHAT_IMAGES } from '../data/chatImages';

export function FloatingJaneChat() {
    const location = useLocation();

    if (location.pathname === '/contact') {
        return null;
    }

    return (
        <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            onClick={redirectToContact}
            className="fixed bottom-6 right-6 z-50 flex items-center gap-3 pl-1.5 pr-5 py-2 rounded-full bg-primary text-primary-foreground shadow-lg hover:scale-105 transition-transform group"
            data-testid="chat-widget-button"
            aria-label="Chat with Ruby"
        >
            <span className="relative flex-shrink-0">
                <span className="absolute inset-0 rounded-full bg-white/30 animate-ping opacity-40" />
                <img
                    src={CHAT_IMAGES.rubyAvatar}
                    alt="Ruby — XDigital AI assistant"
                    className="relative w-16 h-16 rounded-full object-cover border-2 border-white/80 shadow-md group-hover:border-white transition-colors"
                />
            </span>
            <span className="font-medium text-sm whitespace-nowrap">Chat with Ruby</span>
        </motion.button>
    );
}

export default FloatingJaneChat;
